import React from 'react';
import './Drawer.css';

export default function Drawer({ open, onClose, eyebrow, title, subtitle, children, footer, width, className }) {
  if (!open) return null;
  return (
    <div className="drawer-overlay is-open" onClick={onClose}>
      <div className={`drawer-panel${className ? ` ${className}` : ''}`} style={width ? { width } : undefined} onClick={(e) => e.stopPropagation()}>
        <div className="drawer-panel__head">
          <div>
            {eyebrow && <div className="drawer-panel__eyebrow">{eyebrow}</div>}
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button className="drawer-panel__close" onClick={onClose} aria-label="Luk">×</button>
        </div>
        <div className="drawer-panel__body">{children}</div>
        {footer && <div className="drawer-panel__footer">{footer}</div>}
      </div>
    </div>
  );
}
